import React from 'react'
import walkingPizza from 'assets/svg/walking-pizza.svg'
import walkingWatermelon from 'assets/svg/walking-watermelon.svg'
import walkingFries from 'assets/svg/walking-fries.svg'
import LazyImage from 'app/theme/LazyImage'
import cateringBanner from 'assets/img/catering-banner-760.png'
import { Link } from 'react-router-dom'

export default function BookTruckBar(props) {
  const { url, className, ...rest } = props;

  return(
    <a
      href={url}
      {...rest}
      className={[
        className,
        'block w-full bg-blue px-4 sm:px-6 py-5 sm:flex flex-row sm:py-2 sm:items-center sm:justify-between'
      ]}
    >
      <div
        className={[
          'flex items-center justify-center mb-2',
          'sm:order-2 sm:mb-0 sm:text-right sm:justify-end'
        ]}
      >
        <LazyImage
          src={walkingPizza}
          width="34"
          alt="Pizza"
        />
        <LazyImage
          src={walkingWatermelon}
          width="50"
          alt="Watermelon"
        />
        <LazyImage
          src={walkingFries}
          width="40"
          className="ml-2"
          alt="Fries"
        />
      </div>
      <p className="sm:order-1 font-light text-center leading-none text-white text-2xl xl:text-3xl">
        We’ll book a food truck for your next event
      </p>
    </a>
  )
}


export function BookTruckBannerV2({ url, className, ...rest } = {}) {
  return(
    <a
      href={url}
      {...rest}
      className={[
        className,
        'block w-full'
      ]}
    >
      <img src={cateringBanner} alt="Food truck catering" />
    </a>
  )
}

export function BookTruckBannerV3({ url, className, city, ...rest } = {}) {

  if (!city) {
    return null
  }

  return (
    <p className="font-light font-national">
      Looking to hire a {city.name} food truck for your event? We make the research
      and booking process super easy! Get{' '}
      <Link to={url} className="text-blue">{city.name} Food Truck Catering</Link>.
    </p>
  )
}